import { render, staticRenderFns } from "./BreadcrumbPage.vue?vue&type=template&id=db01a508&scoped=true&"
import script from "./BreadcrumbPage.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbPage.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbPage.vue?vue&type=style&index=0&id=db01a508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db01a508",
  null
  
)

export default component.exports